import { Check, CircleDot, Cloud, AlertCircle } from "lucide-react";

export default function AutosaveChip({ status }) {
  const map = {
    idle:   { icon: CircleDot,   text: "Idle",         cls: "text-slate-400" },
    saving: { icon: Cloud,       text: "Saving…",      cls: "text-amber-600 sq-saving" },
    saved:  { icon: Check,       text: "Saved",        cls: "text-emerald-600" },
    error:  { icon: AlertCircle, text: "Save failed",  cls: "text-rose-600 font-semibold" },
  };
  const s = map[status] || map.idle;
  const Icon = s.icon;
  return (
    <span
      data-testid="autosave-status-chip"
      data-autosave-state={status}
      className={`inline-flex items-center gap-1.5 text-xs ${s.cls}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {s.text}
    </span>
  );
}
